import script from "./adjust.vue?vue&type=script&setup=true&lang=js"
export * from "./adjust.vue?vue&type=script&setup=true&lang=js"

import "./adjust.vue?vue&type=style&index=0&id=64e3a468&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/rk-storeroom-webui_feature_1.0.1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e3a468"]])

export default __exports__